import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail, MessageCircle, MessageSquare, X } from "lucide-react";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-4 right-4 md:bottom-5 md:right-5 z-40" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.98 }}
            transition={{ duration: 0.25 }}
            className="mb-3 w-72 bg-white border border-[#0d1b3e]/10 shadow-2xl"
          >
            <div className="px-5 pt-5 pb-3">
              <div className="eyebrow">Talk to a human</div>
              <p className="serif text-xl mt-1 text-[#0d1b3e]">Bonjour, how can we help?</p>
            </div>
            <a href="https://wa.me/33618797689" target="_blank" rel="noreferrer"
              className="flex items-center gap-3 px-5 py-4 border-t border-[#0d1b3e]/10 hover:bg-[#f5f1e8] transition-colors"
              data-testid="fc-whatsapp">
              <MessageCircle size={18} className="text-[#b8892b]" />
              <div>
                <div className="text-sm font-semibold text-[#0d1b3e]">WhatsApp</div>
                <div className="text-xs text-[#4a5570]">+33 6 18 79 76 89</div>
              </div>
            </a>
            <a href="mailto:francepathfr@gmail.com"
              className="flex items-center gap-3 px-5 py-4 border-t border-[#0d1b3e]/10 hover:bg-[#f5f1e8] transition-colors"
              data-testid="fc-email">
              <Mail size={18} className="text-[#b8892b]" />
              <div>
                <div className="text-sm font-semibold text-[#0d1b3e]">Email</div>
                <div className="text-xs text-[#4a5570]">francepathfr@gmail.com</div>
              </div>
            </a>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="floating-contact-toggle"
        className="w-12 h-12 md:w-14 md:h-14 bg-[#0d1b3e] text-white hover:bg-[#b8892b] transition-colors flex items-center justify-center shadow-2xl"
        aria-label="Contact"
      >
        {open ? <X size={20} /> : <MessageSquare size={20} />}
      </button>
    </div>
  );
}
